var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',[_c('charts-bar',{key:_vm.key,staticClass:"view-loyalty-referral__chart",attrs:{"datasets":_vm.datasets,"labels":_vm.labels,"stacked":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }